<template>
  <a-row style="margin: 0 -12px">
    <a-col style="padding: 0 12px" :xl="6" :lg="24" :md="24" :sm="24" :xs="24">
      <a-card title="字典名称" :bordered="false" :loading="loadingData">
        <a slot="extra" @click="create"> <a-icon type="plus" />新建 </a>
        <a-input-search
          style="margin-bottom: 8px"
          placeholder="请输入名称"
          v-model="params.name"
          @change="loadData"
        />
        <ul class="roles">
          <li
            v-for="item in dicts0"
            :class="{ active: item.id == activeDict.id }"
            :key="item.id"
            @click="onClickDict(item)"
          >
            {{ item.name }}

            <a-dropdown :trigger="['click']">
              <a class="ant-dropdown-link" @click="(e) => e.preventDefault()">
                <a-icon type="more" />
              </a>
              <div slot="overlay" class="actions">
                <p @click="onEdit(item)">编辑</p>
                <a-popconfirm
                  title="确认删除吗?"
                  ok-text="是"
                  cancel-text="否"
                  @confirm="del(item.id)"
                >
                  <p>删除</p>
                </a-popconfirm>
              </div>
            </a-dropdown>
          </li>
        </ul>
      </a-card>
    </a-col>
    <a-col style="padding: 0 12px" :xl="18" :lg="24" :md="24" :sm="24" :xs="24">
      <a-card
        :loading="loadingData || loading"
        :bordered="false"
        :title="activeDict.name ? activeDict.name : '...'"
      >
        <div class="btn-group">
          <a-button type="primary" @click="createItem">新增字段</a-button>
        </div>

        <a-table
          :columns="columns"
          :data-source="dataSource"
          :pagination="false"
          :loading="loading"
        >
          <div
            v-if="row.entries"
            slot="expandedRowRender"
            slot-scope="row"
            style="margin: 0"
          >
            <a-table
              :columns="columns"
              :data-source="row.entries"
              :pagination="false"
              :loading="loading"
            >
              <span slot="action" slot-scope="row">
                <a-button type="link" size="small" @click="onEditDictItem(row)"
                  >编辑</a-button
                >
                <a-popconfirm
                  title="确认删除吗?"
                  ok-text="是"
                  cancel-text="否"
                  @confirm="delDictItem(row.id)"
                >
                  <a-button type="link" size="small">删除</a-button>
                </a-popconfirm>
              </span>
            </a-table>
          </div>
          <span slot="action" slot-scope="row">
            <a-button type="link" size="small" @click="onEditDictItem(row)"
              >编辑</a-button
            >
            <a-popconfirm
              title="确认删除吗?"
              ok-text="是"
              cancel-text="否"
              @confirm="delDictItem(row.id)"
            >
              <a-button type="link" size="small">删除</a-button>
            </a-popconfirm>
          </span>
        </a-table>
      </a-card>
    </a-col>
    <!--  新建弹窗  -->
    <a-modal
      :title="dictFrom.id ? '编辑' : '新建'"
      :visible="createVisible"
      @ok="submit"
      @cancel="createVisible = false"
    >
      <a-form-model ref="addzidian" :model="dictFrom" :rules="addzidianRule">
        <a-form-model-item
          label="名称"
          :labelCol="{ span: 5 }"
          :wrapperCol="{ span: 17 }"
          prop="name"
        >
          <a-input v-model="dictFrom.name" placeholder="请输入名称" />
        </a-form-model-item>
        <a-form-model-item
          label="编码"
          :labelCol="{ span: 5 }"
          :wrapperCol="{ span: 17 }"
          prop="code"
        >
          <a-input v-model="dictFrom.code" placeholder="请输入编码" />
        </a-form-model-item>
      </a-form-model>
    </a-modal>

    <!--  新建字段弹窗  -->
    <a-modal
      :title="dictItemFrom.id ? '编辑字段' : '新建字段'"
      :visible="createItemVisible"
      @ok="submitDictItem"
      @cancel="createItemVisible = false"
    >
      <a-form-model
        ref="addziduan"
        :model="dictItemFrom"
        :rules="addziduanRules"
      >
        <a-form-model-item
          label="字段名"
          :labelCol="{ span: 5 }"
          :wrapperCol="{ span: 17 }"
          prop="name"
        >
          <a-input v-model="dictItemFrom.name" placeholder="请输入字段名" />
        </a-form-model-item>
        <a-form-model-item
          label="编码"
          :labelCol="{ span: 5 }"
          :wrapperCol="{ span: 17 }"
          prop="code"
        >
          <a-input v-model="dictItemFrom.code" placeholder="请输入编码" />
        </a-form-model-item>
        <a-form-model-item
          label="父节点"
          :labelCol="{ span: 5 }"
          :wrapperCol="{ span: 17 }"
          prop="parentId"
        >
          <a-select placeholder="请选择父节点" v-model="dictItemFrom.parentId">
            <a-select-option
              v-for="item in dataSource"
              :value="item.id"
              :key="item.id"
              >{{ item.name }}</a-select-option
            >
          </a-select>
        </a-form-model-item>
        <a-form-model-item
          label="备注"
          :labelCol="{ span: 5 }"
          :wrapperCol="{ span: 17 }"
          prop="remark"
        >
          <a-input v-model="dictItemFrom.remark" placeholder="请输入备注" />
        </a-form-model-item>
        <a-form-model-item
          label="顺序"
          :labelCol="{ span: 5 }"
          :wrapperCol="{ span: 17 }"
          prop="sort"
        >
          <a-input
            type="number"
            v-model="dictItemFrom.sort"
            placeholder="请输入顺序"
          />
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </a-row>
</template>

<script>
import * as service from "@/services/dict";

const columns = [
  {
    title: "字段名",
    dataIndex: "name",
  },
  {
    title: "备注",
    dataIndex: "remark",
  },
  {
    title: "编码",
    dataIndex: "code",
  },
  {
    title: "操作",
    key: "action",
    scopedSlots: { customRender: "action" },
  },
];

const dataSource = [];

export default {
  name: "Dict",
  data() {
    return {
      addzidianRule: {
        name: [{ required: true, message: "请填写名称", trigger: "change" }],
        code: [{ required: true, message: "请填写编码", trigger: "change" }],
      },
      addziduanRules: {
        name: [{ required: true, message: "请填写名称", trigger: "change" }],
        code: [{ required: true, message: "请填写编码", trigger: "change" }],
        sort: [{ required: true, message: "请填写顺序", trigger: "change" }],
      },
      createVisible: false,
      createItemVisible: false,
      dictFrom: {},
      dictItemFrom: {
        name: undefined,
        code: undefined,
        defineId: undefined,
        sort: 0,
      },
      activeDict: {},
      dicts: [],
      loading: false,
      loadingData: false,
      columns,
      dataSource,
      params: {
        name: "",
      },
    };
  },
  methods: {
    onClickDict(item) {
      this.activeDict = item;
      this.loadDictItem(item.id);
    },
    async loadData() {
      this.loadingData = true;
      this.dicts = await service.getAll();
      this.loadingData = false;
    },
    create() {
      (this.dictFrom = {}), (this.createVisible = true);
    },
    onEdit(item) {
      console.log(this.dictFrom)

      this.dictFrom = Object.assign({}, item);
      this.createVisible = true;
    },
    async submit() {
      this.$refs.addzidian.validate(async (valid) => {
        if (valid) {
          if (this.dictFrom.id) {
            await service.update(this.dictFrom);
          } else {
            await service.save(this.dictFrom);
          }
          this.$message.success("操作成功");
          this.createVisible = false;
          this.loadData();
        }
      });
    },
    async del(id) {
      await service.del(id);
      this.$message.success("操作成功");
      this.loadData();
    },
    createItem() {
      this.createItemVisible = true;
      this.dictItemFrom = {};
    },
    onEditDictItem(item) {
      this.dictItemFrom = Object.assign({}, item);
      this.createItemVisible = true;
    },
    async loadDictItem(id) {
      this.dataSource = [];
      this.loading = true;
      this.dataSource = await service.getTreeByDicId(id);
      this.loading = false;
    },
    async submitDictItem() {
      this.$refs.addziduan.validate(async (valid) => {
        if (valid) {
          this.dictItemFrom.defineId = this.activeDict.id;
          if (this.dictItemFrom.id) {
            await service.updateItem(this.dictItemFrom);
          } else {
            await service.saveItem(this.dictItemFrom);
          }
          this.$message.success("操作成功");
          this.createItemVisible = false;
          this.loadDictItem(this.activeDict.id);
        }
      });
    },
    async delDictItem(id) {
      await service.delItem(id);
      this.$message.success("操作成功");
      this.loadDictItem(this.activeDict.id);
    },
  },
  computed: {
    dicts0() {
      return this.dicts.filter((o) => o.name.indexOf(this.params.name) > -1);
    },
  },
  async mounted() {
    await this.loadData();
    if (this.dicts.length > 0) {
      this.onClickDict(this.dicts[0]);
    }
  },
};
</script>

<style lang="less" scoped>
.actions {
  background: #fff;
  border: 1px solid #e5e5e5;
}
.roles {
  list-style: none;
  margin-block-start: 0;
  margin-block-end: 0;
  padding-inline-start: 0;
  li {
    padding: 15px 0;
    border-bottom: 1px solid #e8e8e8;
    display: flex;
    justify-content: space-between;
    cursor: pointer;
  }
  .active {
    color: @primary-color;
  }
}
</style>